<template>
  <div>
    <file-pond
      ref="pond"
      name="test"
      allow-multiple="true"
      allow-replace="false"
      allow-remove="false"
      allow-revert="false"
      max-files="3"
      :server="fileServer"
      @processfiles="onProcessFiles"
    />

    <div v-if="loading" class="flex justify-center py-10">
      <d-loader />
    </div>
    <div v-else class="flex -mx-8 divide-x-4 divide-secondary-500 pt-10">
      <div class="w-1/2 px-8 pb-10">
        <p class="text-3xl font-bold">
          Uncategorized Files
        </p>
        <div v-if="uncategorizedFiles.length === 0" class="pt-3">
          No files are currently available for viewing.
        </div>
        <div v-else class="divide-y divide-secondary-400">
          <div v-for="file in uncategorizedFiles" :key="file.id" class="flex justify-between items-center p-5 divide-y divide-secondary-500">
            <div class="flex items-center">
              <img :src="file.iconUrl" alt="Icon Image" class="h-10">
              <div class="mx-5">
                <p>{{ file.name }}</p>
                <p class="text-sm">
                  {{ file.createdAt | formatDate }}
                </p>
              </div>
            </div>
            <d-icon icon="trash" class="text-error cursor-pointer" @click="removeItem(file)" />
          </div>
        </div>
      </div>
      <div class="w-1/2 px-8 pb-10">
        <p class="text-3xl font-bold">
          Categorized Files
        </p>
        <div v-if="categorizedFiles.length === 0" class="pt-3">
          No files are currently available for viewing.
        </div>
        <div v-else class="divide-y divide-secondary-400">
          <div v-for="file in categorizedFiles" :key="file.id" class="flex justify-between items-center p-5">
            <div class="flex items-center">
              <img :src="file.iconUrl" alt="Icon Image" class="h-10">
              <div class="mx-5">
                <p>{{ file.name }}</p>
                <p class="text-sm">
                  {{ file.createdAt | formatDate }}
                </p>
              </div>
            </div>
            <d-icon icon="trash" class="text-error cursor-pointer" @click="removeItem(file)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import {
    getItems, uploadFile, createItem, deleteItem,
  } from '@resources/scripts/services/contentListingItemsApi.service';
  import { ListingItemType, ContentListingType } from '@resources/scripts/constants';

  const FilePond = vueFilePond(FilePondPluginFileValidateType);

  export default {
    inject: ['contentListing'],
    components: {
      FilePond,
    },

    data() {
      return {
        loading: false,
        uncategorizedFiles: [],
        categorizedFiles: [],
        fileServer: {
          process: async (fieldName, file, metadata, load) => {
            const fileUrl = await uploadFile(this.contentListing.id, file, this.contentListing.type);
            const newItemForm = {
              url: fileUrl,
              contentListingId: this.contentListing.id,
              type: ListingItemType.FILE,
              content: fileUrl,
              name: file.name,
            };
            const itemData = await createItem(newItemForm, this.contentListing.id, this.contentListing.type);
            load(itemData);
          },
        },
      };
    },

    mounted() {
      this.getFiles();
    },

    methods: {
      async getFiles() {
        this.loading = true;
        const uncategorizedFiles = await getItems(this.contentListing.id, this.contentListing.type, false);
        this.uncategorizedFiles = uncategorizedFiles.filter((m) => m.type === ListingItemType.FILE);
        const categorizedFiles = await getItems(this.contentListing.id, this.contentListing.type, true);
        if (this.contentListing.type === ContentListingType.STATIC) {
          this.categorizedFiles = this.flattenArray(categorizedFiles).filter((m) => m.type === ListingItemType.FILE);
        } else {
          this.categorizedFiles = categorizedFiles.filter((m) => m.type === ListingItemType.FILE);
        }
        this.loading = false;
      },

      flattenArray(array, parentId = null) {
        let result = [];
        array.forEach((a) => {
          a.parentFolderId = parentId;
          a.categorized = true;
          result.push(a);
          if (a.childItems.length > 0) {
            result = result.concat(this.flattenArray(a.childItems, a.id));
          }
        });
        return result;
      },

      async removeItem(item) {
        await deleteItem(item.id, this.contentListing.type);
        await this.getFiles();
      },

      onProcessFiles() {
        this.getFiles();
      },
    },
  };
</script>